import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=81992e3c&scoped=true"
import script from "./DynamicForm.vue?vue&type=script&lang=js"
export * from "./DynamicForm.vue?vue&type=script&lang=js"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&id=81992e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81992e3c",
  null
  
)

export default component.exports